import { AuthContext, AuthContextType, useAsync, useRequiredParams } from '../../utilities/customHooks';
import { getName } from '../../services/userService';
import LoadingIndicator from '../../Components/LoadingIndicator';
import ErrorIndicator from '../../Components/ErrorIndicator';
import { getSowDetails } from '../../services/serviceProvider';
import CreateSOW from './createSOW2';
import * as T from "../../utilities/frontendTypes";
import EditSOW from './EditSOW';

function SowDetailsConsole() {
``
    const sowId = useRequiredParams("sowId");
    const sowRequestDetailsAsync = useAsync(() => getSowDetails(sowId), []);

    if (sowRequestDetailsAsync.status === "pending") {
      return <LoadingIndicator />;
    }
  
    if (sowRequestDetailsAsync.status === "rejected") {
      return <ErrorIndicator />;
    }
  
  const sowDetails = sowRequestDetailsAsync.value.sowRequestDetails;
  const sowStatus = sowDetails.sowStatus
  const existingRetainerInvoice = sowRequestDetailsAsync.value.existingRetainerInvoice

  console.log(sowDetails)
  const getDashboard = () => {
    switch (sowStatus) {
      case "New SoW Request":
      case "Unsubmitted SoW":
      case "Edit Request from Startup":
      case "Edit Requested from Admin":
        return <CreateSOW sowDetails={sowDetails}/>;
      case "Awaiting Startup Approval":
      case "Awaiting Admin Approval":
      case "Ready to Begin Work": 
        return <EditSOW sowDetails={sowDetails} startupName={sowDetails.startupName} existingRetainerInvoice={existingRetainerInvoice}/>;
      
        // | "Work In Progress" | "Ready for Invoice" | `Project Closed`
        //   case "tempAdmin":
      default:
        throw new Error('Unknown user role');
    }
  }
  return (
    getDashboard()
  )
}

export default SowDetailsConsole